import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const ExecutionSseEventType = {
  TRACE_MESSAGE_ADDED: 'EXECUTION_TRACE_MESSAGE_ADDED',
} as const;

export const ExecutionTraceMessagePayloadSchema = z.object({
  executionId: z.string(),
  traceId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  threadId: z.string(),
  messages: z.array(z.unknown()),
});

export const EXECUTION_TRACE_MESSAGE_ADDED_SSE_EVENT = defineSseEvent({
  type: ExecutionSseEventType.TRACE_MESSAGE_ADDED,
  payload: ExecutionTraceMessagePayloadSchema,
  channelPrefix: 'execution',
  channelKey: ({ executionId }) => executionId,
  target: {
    type: ({ targetType }) => targetType,
    id: ({ targetId }) => targetId,
  },
});

export type ExecutionTraceMessagePayload = z.infer<
  typeof ExecutionTraceMessagePayloadSchema
>;
